<div class="modal-container">
  <div class="modal-content">
    <h1 class="modal-title">{{ isEditMode ? 'Edit Group' : 'Add New Group' }}</h1>
    <form [formGroup]="groupForm">
      <div class="form-row">
        <div class="field-block">
          <label class="field-label" for="groupName">
            Group Name <span class="required">*</span>
          </label>
          <input
            type="text"
            id="groupName"
            formControlName="groupName"
            class="field-input"
            placeholder="Enter group name"
            [attr.maxlength]="groupNameMaxLength"
            [class.field-input-invalid]="groupNameErrorMessage"
            autocomplete="off"
          />
          <span class="hint-text">{{ groupNameHint }}</span>
          <span class="error-text" *ngIf="groupNameErrorMessage">
            {{ groupNameErrorMessage }}
          </span>
        </div>

        <!-- Group Type -->
      <div class="field-block">
        <label class="field-label">
          Group Type <span class="required">*</span>
        </label>
        <div class="radio-group">
          <label class="radio-option">
            <input
              type="radio"
              formControlName="groupType"
              [value]="GROUP_TYPE_COMMON"
            />
            <span class="radio-label"><b>Public:</b> Common (shared across all customers)</span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              formControlName="groupType"
              [value]="GROUP_TYPE_CUSTOMER_SPECIFIC"
            />
            <span class="radio-label"><b>Private:</b> Customer-Specific</span>
          </label>
        </div>
      </div>
  
      <!-- Customer Dropdown -->
      <div class="field-block" *ngIf="isCustomerSpecific">
        <label class="field-label" for="customerId">
          Customer <span class="required">*</span>
        </label>
        <div class="select-wrapper">
          <select id="customerId" formControlName="customerId" class="field-select">
            <option value="">-- Select Customer --</option>
            @for (customer of customersList; track customer.id) {
              <option [value]="customer.id">{{ customer.customerName }}</option>
            }
          </select>
          <span class="select-arrow">&#9660;</span>
        </div>
      </div>
        
      </div>
      
      
  
      
  
      <!-- Buttons -->
      <div class="button-container">
        <button
          type="button"
          mat-stroked-button
          class="btn-cancel"
          (click)="onCancel()"
          mat-dialog-close
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn-confirm"
          [disabled]="groupForm.invalid || isSubmitting"
          (click)="onSubmit()"
        >
          {{ isEditMode ? 'Update Group' : 'Add Group' }}
        </button>
      </div>
      </form>
  </div>
  

  
</div>
